import FRENCH_MODIFIERS from "./FrenchModifiers";
import CivilizationModifiers from "../../model/CivilizationModifiers";
import ENGLISH_MODIFIERS from "./EnglishModifiers";
import CHINESE_MODIFIERS from "./ChineseModifiers";
import MONGOLS_MODIFIERS from "./MongolsModifiers";
import RUS_MODIFIERS from "./RusModifiers";
import DELHI_MODIFIERS from "./DelhiModifiers";
import ABBASID_MODIFIERS from "./AbbasidModifiers";
import OTTOMANS_MODIFIERS from "./OttomansModifiers";
import MALIANS_MODIFIERS from "./MaliansModifiers";
import JEANNE_D_ARC_MODIFIERS from "./JeanneDArcModfiers";
import DRAGON_ORDER_MODIFIERS from "./DragonOrderModifiers";
import ZHU_XIS_LEGACY_MODIFIERS from "./ZhuXisLegacyModfiers";
import AYYUBIDS_MODIFIERS from "./AyyubidsModifiers";
import JAPANESE_MODIFIERS from "./JapaneseModifiers";
import BYZANTINES_MODIFIERS from "./ByzantinesModifiers";
import KNIGHTS_TEMPLAR_MODIFIERS from "./KnightsTemplarModifiers";
import HOUSE_OF_LANCASTER_MODIFIERS from "./HouseOfLancasterModifiers";
import GOLDEN_HORDE_MODIFIERS from "./GoldenHordeModifiers";
import MACEDONIAN_DYNASTY_MODIFIERS from "./MacedonianDynastyModifiers";
import SENGOKU_DAIMYO_MODIFIERS from "./SengokuDaimyoModifiers";
import TUGHLAQ_DYNASTY_MODIFIERS from "./TughlaqDynastyModifiers";

const allCivilizationModifiers: CivilizationModifiers[] = [
    FRENCH_MODIFIERS,
    ENGLISH_MODIFIERS,
    CHINESE_MODIFIERS,
    MONGOLS_MODIFIERS,
    RUS_MODIFIERS,
    DELHI_MODIFIERS,
    ABBASID_MODIFIERS,
    OTTOMANS_MODIFIERS,
    MALIANS_MODIFIERS,
    JEANNE_D_ARC_MODIFIERS,
    DRAGON_ORDER_MODIFIERS,
    ZHU_XIS_LEGACY_MODIFIERS,
    AYYUBIDS_MODIFIERS,
    JAPANESE_MODIFIERS,
    BYZANTINES_MODIFIERS,
    KNIGHTS_TEMPLAR_MODIFIERS,
    HOUSE_OF_LANCASTER_MODIFIERS,
    GOLDEN_HORDE_MODIFIERS,
    MACEDONIAN_DYNASTY_MODIFIERS,
    SENGOKU_DAIMYO_MODIFIERS,
    TUGHLAQ_DYNASTY_MODIFIERS
];

export default allCivilizationModifiers;
